import { Datagrid, DateField, List, NumberField, TextField, FunctionField } from "react-admin";
import { Chip } from "@mui/material";
import { DocumentTransformation, DocumentTransformationStatus } from "@/types/documentTransformation";

// The per-record show page was removed; transformation details are now
// surfaced via TransformationDetailsDialog on the parent Document show.
// This list remains as an admin-tier cross-document catalog, but row
// navigation belongs back to the parent document, not a dedicated
// transformation page.

const statusColors: Record<DocumentTransformationStatus, "default" | "success" | "warning" | "error" | "info"> = {
  [DocumentTransformationStatus.PROCESSING]: "info",
  [DocumentTransformationStatus.COMPLETED]: "success",
  [DocumentTransformationStatus.FAILED]: "error",
  [DocumentTransformationStatus.REVIEW_REQUIRED]: "warning",
  [DocumentTransformationStatus.LOADED]: "success",
};

export const DocumentTransformationList = () => (
  <List sort={{ field: "created_datetime", order: "DESC" }} perPage={25} exporter={false}>
    <Datagrid bulkActionButtons={false}>
      <TextField source="id" label="ID" />
      {/* aegle_id is not a real transformation column; not server-sortable. */}
      <TextField source="aegle_id" label="Aegle ID" sortable={false} />
      {/* document_id_ref is a display rename of document_id; not in the sort allow-list. */}
      <TextField source="document_id_ref" label="Document ID" sortable={false} />

      <FunctionField
        label="Status"
        sortBy="status"
        render={(record: DocumentTransformation) => (
          <Chip label={record.status} color={statusColors[record.status] || "default"} size="small" />
        )}
      />

      <NumberField
        source="coverage_percentage"
        label="Coverage %"
        options={{ style: "percent", maximumFractionDigits: 0 }}
        transform={(value: number) => value / 100}
      />

      <FunctionField
        label="Target Schemas"
        sortable={false}
        render={(record: DocumentTransformation) => record.target_schemas?.join(", ") || "N/A"}
      />

      <FunctionField
        label="Processing Time"
        sortable={false}
        render={(record: DocumentTransformation) => {
          const ms = record.processing_metadata?.processing_time_ms;
          if (!ms) return "N/A";
          return `${(ms / 1000).toFixed(1)}s`;
        }}
      />

      <FunctionField
        label="Extraction Method"
        sortable={false}
        render={(record: DocumentTransformation) => record.processing_metadata?.extraction_method || "N/A"}
      />

      <DateField source="created_datetime" label="Created" showTime />
      <DateField source="modified_datetime" label="Modified" showTime />
    </Datagrid>
  </List>
);
